export default __webpack_public_path__ + "static/media/1-Ano-03-Ver-E-Enxergar.1477f889.png";